export default __webpack_public_path__ + "assets/favicon-okc.c0f86857.ico";